import { createMutation } from 'QueryKit'
import { updateReviewState } from 'API/definitions/iris/inspection-image'

const useUpdateReviewStateMutation = createMutation({
    mutationKey: 'inspection-image_update-review-state',
    mutationFn: updateReviewState,
    message: 'Failed to update'
})

export {
    useUpdateReviewStateMutation
}